webpackJsonp([114276838955818,60335399758886],{

/***/ 145:
/***/ (function(module, exports) {

	module.exports = {"data":{"site":{"siteMetadata":{"title":"Whistle Messaging, Inc","description":"Engage With Hotel Guests Pre, During, And Post-Stay. Free Training. No Commitments. Free Setup. Unlimited Messaging. Highlights: Boost Guest Engagement, Improve Customer Service Scores, Streamline Team Messaging, Increase Online Reviews."}},"landing":{"edges":[{"node":{"id":"/home/circleci/project/src/pages/landing/sensorindustries.md absPath of file >>> MarkdownRemark","frontmatter":{"title":"sensorindustries","label":"Sensor Industries"}}},{"node":{"id":"/home/circleci/project/src/pages/landing/mews.md absPath of file >>> MarkdownRemark","frontmatter":{"title":"mews","label":"Mews"}}},{"node":{"id":"/home/circleci/project/src/pages/landing/quore.md absPath of file >>> MarkdownRemark","frontmatter":{"title":"quore","label":"Quore"}}},{"node":{"id":"/home/circleci/project/src/pages/landing/webrezpro.md absPath of file >>> MarkdownRemark","frontmatter":{"title":"webrezpro","label":"WebRezPro"}}},{"node":{"id":"/home/circleci/project/src/pages/landing/stayntouch.md absPath of file >>> MarkdownRemark","frontmatter":{"title":"stayntouch","label":"StayNTouch"}}},{"node":{"id":"/home/circleci/project/src/pages/landing/skytouch.md absPath of file >>> MarkdownRemark","frontmatter":{"title":"skytouch","label":"SkyTouch"}}}]}},"layoutContext":{}}

/***/ }),

/***/ 271:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _index = __webpack_require__(288);
	
	var _index2 = _interopRequireDefault(_index);
	
	var _layoutIndex = __webpack_require__(145);
	
	var _layoutIndex2 = _interopRequireDefault(_layoutIndex);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (props) {
	  return _react2.default.createElement(_index2.default, _extends({}, props, _layoutIndex2.default));
	};
	
	module.exports = exports["default"];

/***/ }),

/***/ 69:
/***/ (function(module, exports, __webpack_require__) {

	var pSlice = Array.prototype.slice;
	var objectKeys = __webpack_require__(71);
	var isArguments = __webpack_require__(70);
	
	var deepEqual = module.exports = function (actual, expected, opts) {
	  if (!opts) opts = {};
	  // 7.1. All identical values are equivalent, as determined by ===.
	  if (actual === expected) {
	    return true;
	
	  } else if (actual instanceof Date && expected instanceof Date) {
	    return actual.getTime() === expected.getTime();
	
	  // 7.3. Other pairs that do not both pass typeof value == 'object',
	  // equivalence is determined by ==.
	  } else if (!actual || !expected || typeof actual != 'object' && typeof expected != 'object') {
	    return opts.strict ? actual === expected : actual == expected;
	
	  // 7.4. For all other Object pairs, including Array objects, equivalence is
	  // determined by having the same number of owned properties (as verified
	  // with Object.prototype.hasOwnProperty.call), the same set of keys
	  // (although not necessarily the same order), equivalent values for every
	  // corresponding key, and an identical 'prototype' property. Note: this
	  // accounts for both named and indexed properties on Arrays.
	  } else {
	    return objEquiv(actual, expected, opts);
	  }
	}
	
	function isUndefinedOrNull(value) {
	  return value === null || value === undefined;
	}
	
	function isBuffer (x) {
	  if (!x || typeof x !== 'object' || typeof x.length !== 'number') return false;
	  if (typeof x.copy !== 'function' || typeof x.slice !== 'function') {
	    return false;
	  }
	  if (x.length > 0 && typeof x[0] !== 'number') return false;
	  return true;
	}
	
	function objEquiv(a, b, opts) {
	  var i, key;
	  if (isUndefinedOrNull(a) || isUndefinedOrNull(b))
	    return false;
	  // an identical 'prototype' property.
	  if (a.prototype !== b.prototype) return false;
	  //~~~I've managed to break Object.keys through screwy arguments passing.
	  //   Converting to array solves the problem.
	  if (isArguments(a)) {
	    if (!isArguments(b)) {
	      return false;
	    }
	    a = pSlice.call(a);
	    b = pSlice.call(b);
	    return deepEqual(a, b, opts);
	  }
	  if (isBuffer(a)) {
	    if (!isBuffer(b)) {
	      return false;
	    }
	    if (a.length !== b.length) return false;
	    for (i = 0; i < a.length; i++) {
	      if (a[i] !== b[i]) return false;
	    }
	    return true;
	  }
	  try {
	    var ka = objectKeys(a),
	        kb = objectKeys(b);
	  } catch (e) {//happens when one is a string literal and the other isn't
	    return false;
	  }
	  // having the same number of owned properties (keys incorporates
	  // hasOwnProperty)
	  if (ka.length != kb.length)
	    return false;
	  //the same set of keys (although not necessarily the same order),
	  ka.sort();
	  kb.sort();
	  //~~~cheap key test
	  for (i = ka.length - 1; i >= 0; i--) {
	    if (ka[i] != kb[i])
	      return false;
	  }
	  //equivalent values for every corresponding key, and
	  //~~~possibly expensive deep test
	  for (i = ka.length - 1; i >= 0; i--) {
	    key = ka[i];
	    if (!deepEqual(a[key], b[key], opts)) return false;
	  }
	  return typeof a === typeof b;
	}


/***/ }),

/***/ 70:
/***/ (function(module, exports) {

	var supportsArgumentsClass = (function(){
	  return Object.prototype.toString.call(arguments)
	})() == '[object Arguments]';
	
	exports = module.exports = supportsArgumentsClass ? supported : unsupported;
	
	exports.supported = supported;
	function supported(object) {
	  return Object.prototype.toString.call(object) == '[object Arguments]';
	};
	
	exports.unsupported = unsupported;
	function unsupported(object){
	  return object &&
	    typeof object == 'object' &&
	    typeof object.length == 'number' &&
	    Object.prototype.hasOwnProperty.call(object, 'callee') &&
	    !Object.prototype.propertyIsEnumerable.call(object, 'callee') ||
	    false;
	};


/***/ }),

/***/ 71:
/***/ (function(module, exports) {

	exports = module.exports = typeof Object.keys === 'function'
	  ? Object.keys : shim;
	
	exports.shim = shim;
	function shim (obj) {
	  var keys = [];
	  for (var key in obj) keys.push(key);
	  return keys;
	}


/***/ }),

/***/ 72:
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;/*!
	  Copyright (c) 2015 Jed Watson.
	  Based on code that is Copyright 2013-2015, Facebook, Inc.
	  All rights reserved.
	*/
	/* global define */
	
	(function () {
		'use strict';
	
		var canUseDOM = !!(
			typeof window !== 'undefined' &&
			window.document &&
			window.document.createElement
		);
	
		var ExecutionEnvironment = {
	
			canUseDOM: canUseDOM,
	
			canUseWorkers: typeof Worker !== 'undefined',
	
			canUseEventListeners:
				canUseDOM && !!(window.addEventListener || window.attachEvent),
	
			canUseViewport: canUseDOM && !!window.screen
	
		};
	
		if (true) {
			!(__WEBPACK_AMD_DEFINE_RESULT__ = function () {
				return ExecutionEnvironment;
			}.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		} else if (typeof module !== 'undefined' && module.exports) {
			module.exports = ExecutionEnvironment;
		} else {
			window.ExecutionEnvironment = ExecutionEnvironment;
		}
	
	}());


/***/ }),

/***/ 402:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 80:
/***/ (function(module, exports, __webpack_require__) {

	exports.__esModule = true;
	exports.Helmet = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(8);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactSideEffect = __webpack_require__(82);
	
	var _reactSideEffect2 = _interopRequireDefault(_reactSideEffect);
	
	var _deepEqual = __webpack_require__(69);
	
	var _deepEqual2 = _interopRequireDefault(_deepEqual);
	
	var _HelmetUtils = __webpack_require__(81);
	
	var _HelmetConstants = __webpack_require__(27);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Helmet = function Helmet(Component) {
	    var _class, _temp;
	
	    return _temp = _class = function (_React$Component) {
	        _inherits(HelmetWrapper, _React$Component);
	
	        function HelmetWrapper() {
	            _classCallCheck(this, HelmetWrapper);
	
	            return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
	        }
	
	        HelmetWrapper.prototype.shouldComponentUpdate = function shouldComponentUpdate(nextProps) {
	            return !(0, _deepEqual2.default)(this.props, nextProps);
	        };
	
	        HelmetWrapper.prototype.mapNestedChildrenToProps = function mapNestedChildrenToProps(child, nestedChildren) {
	            if (!nestedChildren) {
	                return null;
	            }
	
	            switch (child.type) {
	                case _HelmetConstants.TAG_NAMES.SCRIPT:
	                case _HelmetConstants.TAG_NAMES.NOSCRIPT:
	                    return {
	                        innerHTML: nestedChildren
	                    };
	
	                case _HelmetConstants.TAG_NAMES.STYLE:
	                    return {
	                        cssText: nestedChildren
	                    };
	            }
	
	            throw new Error("<" + child.type + " /> elements are self-closing and can not contain children. Refer to our API for more information.");
	        };
	
	        HelmetWrapper.prototype.flattenArrayTypeChildren = function flattenArrayTypeChildren(_ref) {
	            var _extends2;
	
	            var child = _ref.child,
	                arrayTypeChildren = _ref.arrayTypeChildren,
	                newChildProps = _ref.newChildProps,
	                nestedChildren = _ref.nestedChildren;
	
	            return _extends({}, arrayTypeChildren, (_extends2 = {}, _extends2[child.type] = [].concat(arrayTypeChildren[child.type] || [], [_extends({}, newChildProps, this.mapNestedChildrenToProps(child, nestedChildren))]), _extends2));
	        };
	
	        HelmetWrapper.prototype.mapObjectTypeChildren = function mapObjectTypeChildren(_ref2) {
	            var _extends3, _extends4;
	
	            var child = _ref2.child,
	                newProps = _ref2.newProps,
	                newChildProps = _ref2.newChildProps,
	                nestedChildren = _ref2.nestedChildren;
	
	            switch (child.type) {
	                case _HelmetConstants.TAG_NAMES.TITLE:
	                    return _extends({}, newProps, (_extends3 = {}, _extends3[child.type] = nestedChildren, _extends3.titleAttributes = _extends({}, newChildProps), _extends3));
	
	                case _HelmetConstants.TAG_NAMES.BODY:
	                    return _extends({}, newProps, {
	                        bodyAttributes: _extends({}, newChildProps)
	                    });
	
	                case _HelmetConstants.TAG_NAMES.HTML:
	                    return _extends({}, newProps, {
	                        htmlAttributes: _extends({}, newChildProps)
	                    });
	            }
	
	            return _extends({}, newProps, (_extends4 = {}, _extends4[child.type] = _extends({}, newChildProps), _extends4));
	        };
	
	        HelmetWrapper.prototype.mapArrayTypeChildrenToProps = function mapArrayTypeChildrenToProps(arrayTypeChildren, newProps) {
	            var newFlattenedProps = _extends({}, newProps);
	
	            Object.keys(arrayTypeChildren).forEach(function (arrayChildName) {
	                var _extends5;
	
	                newFlattenedProps = _extends({}, newFlattenedProps, (_extends5 = {}, _extends5[arrayChildName] = arrayTypeChildren[arrayChildName], _extends5));
	            });
	
	            return newFlattenedProps;
	        };
	
	        HelmetWrapper.prototype.warnOnInvalidChildren = function warnOnInvalidChildren(child, nestedChildren) {
	            if (false) {
	                if (!_HelmetConstants.VALID_TAG_NAMES.some(function (name) {
	                    return child.type === name;
	                })) {
	                    if (typeof child.type === "function") {
	                        return (0, _HelmetUtils.warn)("You may be attempting to nest <Helmet> components within each other, which is not allowed. Refer to our API for more information.");
	                    }
	
	                    return (0, _HelmetUtils.warn)("Only elements types " + _HelmetConstants.VALID_TAG_NAMES.join(", ") + " are allowed. Helmet does not support rendering <" + child.type + "> elements. Refer to our API for more information.");
	                }
	
	                if (nestedChildren && typeof nestedChildren !== "string" && (!Array.isArray(nestedChildren) || nestedChildren.some(function (nestedChild) {
	                    return typeof nestedChild !== "string";
	                }))) {
	                    throw new Error("Helmet expects a string as a child of <" + child.type + ">. Did you forget to wrap your children in braces? ( <" + child.type + ">{``}</" + child.type + "> ) Refer to our API for more information.");
	                }
	            }
	
	            return true;
	        };
	
	        HelmetWrapper.prototype.mapChildrenToProps = function mapChildrenToProps(children, newProps) {
	            var _this2 = this;
	
	            var arrayTypeChildren = {};
	
	            _react2.default.Children.forEach(children, function (child) {
	                if (!child || !child.props) {
	                    return;
	                }
	
	                var _child$props = child.props,
	                    nestedChildren = _child$props.children,
	                    childProps = _objectWithoutProperties(_child$props, ["children"]);
	
	                var newChildProps = (0, _HelmetUtils.convertReactPropstoHtmlAttributes)(childProps);
	
	                _this2.warnOnInvalidChildren(child, nestedChildren);
	
	                switch (child.type) {
	                    case _HelmetConstants.TAG_NAMES.LINK:
	                    case _HelmetConstants.TAG_NAMES.META:
	                    case _HelmetConstants.TAG_NAMES.NOSCRIPT:
	                    case _HelmetConstants.TAG_NAMES.SCRIPT:
	                    case _HelmetConstants.TAG_NAMES.STYLE:
	                        arrayTypeChildren = _this2.flattenArrayTypeChildren({
	                            child: child,
	                            arrayTypeChildren: arrayTypeChildren,
	                            newChildProps: newChildProps,
	                            nestedChildren: nestedChildren
	                        });
	                        break;
	
	                    default:
	                        newProps = _this2.mapObjectTypeChildren({
	                            child: child,
	                            newProps: newProps,
	                            newChildProps: newChildProps,
	                            nestedChildren: nestedChildren
	                        });
	                        break;
	                }
	            });
	
	            newProps = this.mapArrayTypeChildrenToProps(arrayTypeChildren, newProps);
	            return newProps;
	        };
	
	        HelmetWrapper.prototype.render = function render() {
	            var _props = this.props,
	                children = _props.children,
	                props = _objectWithoutProperties(_props, ["children"]);
	
	            var newProps = _extends({}, props);
	
	            if (children) {
	                newProps = this.mapChildrenToProps(children, newProps);
	            }
	
	            return _react2.default.createElement(Component, newProps);
	        };
	
	        _createClass(HelmetWrapper, null, [{
	            key: "canUseDOM",
	
	
	            // Component.peek comes from react-side-effect:
	            // For testing, you may use a static peek() method available on the returned component.
	            // It lets you get the current state without resetting the mounted instance stack.
	            // Don’t use it for anything other than testing.
	
	            /**
	            * @param {Object} base: {"target": "_blank", "href": "http://mysite.com/"}
	            * @param {Object} bodyAttributes: {"className": "root"}
	            * @param {String} defaultTitle: "Default Title"
	            * @param {Boolean} defer: true
	            * @param {Boolean} encodeSpecialCharacters: true
	            * @param {Object} htmlAttributes: {"lang": "en", "amp": undefined}
	            * @param {Array} link: [{"rel": "canonical", "href": "http://mysite.com/example"}]
	            * @param {Array} meta: [{"name": "description", "content": "Test description"}]
	            * @param {Array} noscript: [{"innerHTML": "<img src='http://mysite.com/js/test.js'"}]
	            * @param {Function} onChangeClientState: "(newState) => console.log(newState)"
	            * @param {Array} script: [{"type": "text/javascript", "src": "http://mysite.com/js/test.js"}]
	            * @param {Array} style: [{"type": "text/css", "cssText": "div { display: block; color: blue; }"}]
	            * @param {String} title: "Title"
	            * @param {Object} titleAttributes: {"itemprop": "name"}
	            * @param {String} titleTemplate: "MySite.com - %s"
	            */
	            set: function set(canUseDOM) {
	                Component.canUseDOM = canUseDOM;
	            }
	        }]);
	
	        return HelmetWrapper;
	    }(_react2.default.Component), _class.propTypes = {
	        base: _propTypes2.default.object,
	        bodyAttributes: _propTypes2.default.object,
	        children: _propTypes2.default.oneOfType([_propTypes2.default.arrayOf(_propTypes2.default.node), _propTypes2.default.node]),
	        defaultTitle: _propTypes2.default.string,
	        defer: _propTypes2.default.bool,
	        encodeSpecialCharacters: _propTypes2.default.bool,
	        htmlAttributes: _propTypes2.default.object,
	        link: _propTypes2.default.arrayOf(_propTypes2.default.object),
	        meta: _propTypes2.default.arrayOf(_propTypes2.default.object),
	        noscript: _propTypes2.default.arrayOf(_propTypes2.default.object),
	        onChangeClientState: _propTypes2.default.func,
	        script: _propTypes2.default.arrayOf(_propTypes2.default.object),
	        style: _propTypes2.default.arrayOf(_propTypes2.default.object),
	        title: _propTypes2.default.string,
	        titleAttributes: _propTypes2.default.object,
	        titleTemplate: _propTypes2.default.string
	    }, _class.defaultProps = {
	        defer: true,
	        encodeSpecialCharacters: true
	    }, _class.peek = Component.peek, _class.rewind = function () {
	        var mappedState = Component.rewind();
	        if (!mappedState) {
	            // provide fallback if mappedState is undefined
	            mappedState = (0, _HelmetUtils.mapStateOnServer)({
	                baseTag: [],
	                bodyAttributes: {},
	                encodeSpecialCharacters: true,
	                htmlAttributes: {},
	                linkTags: [],
	                metaTags: [],
	                noscriptTags: [],
	                scriptTags: [],
	                styleTags: [],
	                title: "",
	                titleAttributes: {}
	            });
	        }
	
	        return mappedState;
	    }, _temp;
	};
	
	var NullComponent = function NullComponent() {
	    return null;
	};
	
	var HelmetSideEffects = (0, _reactSideEffect2.default)(_HelmetUtils.reducePropsToState, _HelmetUtils.handleClientStateChange, _HelmetUtils.mapStateOnServer)(NullComponent);
	
	var HelmetExport = Helmet(HelmetSideEffects);
	HelmetExport.renderStatic = HelmetExport.rewind;
	
	exports.Helmet = HelmetExport;
	exports.default = HelmetExport;

/***/ }),

/***/ 27:
/***/ (function(module, exports) {

	exports.__esModule = true;
	var ATTRIBUTE_NAMES = exports.ATTRIBUTE_NAMES = {
	    BODY: "bodyAttributes",
	    HTML: "htmlAttributes",
	    TITLE: "titleAttributes"
	};
	
	var TAG_NAMES = exports.TAG_NAMES = {
	    BASE: "base",
	    BODY: "body",
	    HEAD: "head",
	    HTML: "html",
	    LINK: "link",
	    META: "meta",
	    NOSCRIPT: "noscript",
	    SCRIPT: "script",
	    STYLE: "style",
	    TITLE: "title"
	};
	
	var VALID_TAG_NAMES = exports.VALID_TAG_NAMES = Object.keys(TAG_NAMES).map(function (name) {
	    return TAG_NAMES[name];
	});
	
	var TAG_PROPERTIES = exports.TAG_PROPERTIES = {
	    CHARSET: "charset",
	    CSS_TEXT: "cssText",
	    HREF: "href",
	    HTTPEQUIV: "http-equiv",
	    INNER_HTML: "innerHTML",
	    ITEM_PROP: "itemprop",
	    NAME: "name",
	    PROPERTY: "property",
	    REL: "rel",
	    SRC: "src"
	};
	
	var REACT_TAG_MAP = exports.REACT_TAG_MAP = {
	    accesskey: "accessKey",
	    charset: "charSet",
	    class: "className",
	    contenteditable: "contentEditable",
	    contextmenu: "contextMenu",
	    "http-equiv": "httpEquiv",
	    itemprop: "itemProp",
	    tabindex: "tabIndex"
	};
	
	var HELMET_PROPS = exports.HELMET_PROPS = {
	    DEFAULT_TITLE: "defaultTitle",
	    DEFER: "defer",
	    ENCODE_SPECIAL_CHARACTERS: "encodeSpecialCharacters",
	    ON_CHANGE_CLIENT_STATE: "onChangeClientState",
	    TITLE_TEMPLATE: "titleTemplate"
	};
	
	var HTML_TAG_MAP = exports.HTML_TAG_MAP = Object.keys(REACT_TAG_MAP).reduce(function (obj, key) {
	    obj[REACT_TAG_MAP[key]] = key;
	    return obj;
	}, {});
	
	var SELF_CLOSING_TAGS = exports.SELF_CLOSING_TAGS = [TAG_NAMES.NOSCRIPT, TAG_NAMES.SCRIPT, TAG_NAMES.STYLE];
	
	var HELMET_ATTRIBUTE = exports.HELMET_ATTRIBUTE = "data-react-helmet";

/***/ }),

/***/ 81:
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {exports.__esModule = true;
	exports.warn = exports.requestAnimationFrame = exports.reducePropsToState = exports.mapStateOnServer = exports.handleClientStateChange = exports.convertReactPropstoHtmlAttributes = undefined;
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _objectAssign = __webpack_require__(9);
	
	var _objectAssign2 = _interopRequireDefault(_objectAssign);
	
	var _HelmetConstants = __webpack_require__(27);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var encodeSpecialCharacters = function encodeSpecialCharacters(str) {
	    var encode = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
	
	    if (encode === false) {
	        return String(str);
	    }
	
	    return String(str).replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/"/g, "&quot;").replace(/'/g, "&#x27;");
	};
	
	var getTitleFromPropsList = function getTitleFromPropsList(propsList) {
	    var innermostTitle = getInnermostProperty(propsList, _HelmetConstants.TAG_NAMES.TITLE);
	    var innermostTemplate = getInnermostProperty(propsList, _HelmetConstants.HELMET_PROPS.TITLE_TEMPLATE);
	
	    if (innermostTemplate && innermostTitle) {
	        // use function arg to avoid need to escape $ characters
	        return innermostTemplate.replace(/%s/g, function () {
	            return innermostTitle;
	        });
	    }
	
	    var innermostDefaultTitle = getInnermostProperty(propsList, _HelmetConstants.HELMET_PROPS.DEFAULT_TITLE);
	
	    return innermostTitle || innermostDefaultTitle || undefined;
	};
	
	var getOnChangeClientState = function getOnChangeClientState(propsList) {
	    return getInnermostProperty(propsList, _HelmetConstants.HELMET_PROPS.ON_CHANGE_CLIENT_STATE) || function () {};
	};
	
	var getAttributesFromPropsList = function getAttributesFromPropsList(tagType, propsList) {
	    return propsList.filter(function (props) {
	        return typeof props[tagType] !== "undefined";
	    }).map(function (props) {
	        return props[tagType];
	    }).reduce(function (tagAttrs, current) {
	        return _extends({}, tagAttrs, current);
	    }, {});
	};
	
	var getBaseTagFromPropsList = function getBaseTagFromPropsList(primaryAttributes, propsList) {
	    return propsList.filter(function (props) {
	        return typeof props[_HelmetConstants.TAG_NAMES.BASE] !== "undefined";
	    }).map(function (props) {
	        return props[_HelmetConstants.TAG_NAMES.BASE];
	    }).reverse().reduce(function (innermostBaseTag, tag) {
	        if (!innermostBaseTag.length) {
	            var keys = Object.keys(tag);
	
	            for (var i = 0; i < keys.length; i++) {
	                var attributeKey = keys[i];
	                var lowerCaseAttributeKey = attributeKey.toLowerCase();
	
	                if (primaryAttributes.indexOf(lowerCaseAttributeKey) !== -1 && tag[lowerCaseAttributeKey]) {
	                    return innermostBaseTag.concat(tag);
	                }
	            }
	        }
	
	        return innermostBaseTag;
	    }, []);
	};
	
	var getTagsFromPropsList = function getTagsFromPropsList(tagName, primaryAttributes, propsList) {
	    // Calculate list of tags, giving priority innermost component (end of the propslist)
	    var approvedSeenTags = {};
	
	    return propsList.filter(function (props) {
	        if (Array.isArray(props[tagName])) {
	            return true;
	        }
	        if (typeof props[tagName] !== "undefined") {
	            warn("Helmet: " + tagName + " should be of type \"Array\". Instead found type \"" + _typeof(props[tagName]) + "\"");
	        }
	        return false;
	    }).map(function (props) {
	        return props[tagName];
	    }).reverse().reduce(function (approvedTags, instanceTags) {
	        var instanceSeenTags = {};
	
	        instanceTags.filter(function (tag) {
	            var primaryAttributeKey = void 0;
	            var keys = Object.keys(tag);
	            for (var i = 0; i < keys.length; i++) {
	                var attributeKey = keys[i];
	                var lowerCaseAttributeKey = attributeKey.toLowerCase();
	
	                // Special rule with link tags, since rel and href are both primary tags, rel takes priority
	                if (primaryAttributes.indexOf(lowerCaseAttributeKey) !== -1 && !(primaryAttributeKey === _HelmetConstants.TAG_PROPERTIES.REL && tag[primaryAttributeKey].toLowerCase() === "canonical") && !(lowerCaseAttributeKey === _HelmetConstants.TAG_PROPERTIES.REL && tag[lowerCaseAttributeKey].toLowerCase() === "stylesheet")) {
	                    primaryAttributeKey = lowerCaseAttributeKey;
	                }
	                // Special case for innerHTML which doesn't work lowercased
	                if (primaryAttributes.indexOf(attributeKey) !== -1 && (attributeKey === _HelmetConstants.TAG_PROPERTIES.INNER_HTML || attributeKey === _HelmetConstants.TAG_PROPERTIES.CSS_TEXT || attributeKey === _HelmetConstants.TAG_PROPERTIES.ITEM_PROP)) {
	                    primaryAttributeKey = attributeKey;
	                }
	            }
	
	            if (!primaryAttributeKey || !tag[primaryAttributeKey]) {
	                return false;
	            }
	
	            var value = tag[primaryAttributeKey].toLowerCase();
	
	            if (!approvedSeenTags[primaryAttributeKey]) {
	                approvedSeenTags[primaryAttributeKey] = {};
	            }
	
	            if (!instanceSeenTags[primaryAttributeKey]) {
	                instanceSeenTags[primaryAttributeKey] = {};
	            }
	
	            if (!approvedSeenTags[primaryAttributeKey][value]) {
	                instanceSeenTags[primaryAttributeKey][value] = true;
	                return true;
	            }
	
	            return false;
	        }).reverse().forEach(function (tag) {
	            return approvedTags.push(tag);
	        });
	
	        // Update seen tags with tags from this instance
	        var keys = Object.keys(instanceSeenTags);
	        for (var i = 0; i < keys.length; i++) {
	            var attributeKey = keys[i];
	            var tagUnion = (0, _objectAssign2.default)({}, approvedSeenTags[attributeKey], instanceSeenTags[attributeKey]);
	
	            approvedSeenTags[attributeKey] = tagUnion;
	        }
	
	        return approvedTags;
	    }, []).reverse();
	};
	
	var getInnermostProperty = function getInnermostProperty(propsList, property) {
	    for (var i = propsList.length - 1; i >= 0; i--) {
	        var props = propsList[i];
	
	        if (props.hasOwnProperty(property)) {
	            return props[property];
	        }
	    }
	
	    return null;
	};
	
	var reducePropsToState = function reducePropsToState(propsList) {
	    return {
	        baseTag: getBaseTagFromPropsList([_HelmetConstants.TAG_PROPERTIES.HREF], propsList),
	        bodyAttributes: getAttributesFromPropsList(_HelmetConstants.ATTRIBUTE_NAMES.BODY, propsList),
	        defer: getInnermostProperty(propsList, _HelmetConstants.HELMET_PROPS.DEFER),
	        encode: getInnermostProperty(propsList, _HelmetConstants.HELMET_PROPS.ENCODE_SPECIAL_CHARACTERS),
	        htmlAttributes: getAttributesFromPropsList(_HelmetConstants.ATTRIBUTE_NAMES.HTML, propsList),
	        linkTags: getTagsFromPropsList(_HelmetConstants.TAG_NAMES.LINK, [_HelmetConstants.TAG_PROPERTIES.REL, _HelmetConstants.TAG_PROPERTIES.HREF], propsList),
	        metaTags: getTagsFromPropsList(_HelmetConstants.TAG_NAMES.META, [_HelmetConstants.TAG_PROPERTIES.NAME, _HelmetConstants.TAG_PROPERTIES.CHARSET, _HelmetConstants.TAG_PROPERTIES.HTTPEQUIV, _HelmetConstants.TAG_PROPERTIES.PROPERTY, _HelmetConstants.TAG_PROPERTIES.ITEM_PROP], propsList),
	        noscriptTags: getTagsFromPropsList(_HelmetConstants.TAG_NAMES.NOSCRIPT, [_HelmetConstants.TAG_PROPERTIES.INNER_HTML], propsList),
	        onChangeClientState: getOnChangeClientState(propsList),
	        scriptTags: getTagsFromPropsList(_HelmetConstants.TAG_NAMES.SCRIPT, [_HelmetConstants.TAG_PROPERTIES.SRC, _HelmetConstants.TAG_PROPERTIES.INNER_HTML], propsList),
	        styleTags: getTagsFromPropsList(_HelmetConstants.TAG_NAMES.STYLE, [_HelmetConstants.TAG_PROPERTIES.CSS_TEXT], propsList),
	        title: getTitleFromPropsList(propsList),
	        titleAttributes: getAttributesFromPropsList(_HelmetConstants.ATTRIBUTE_NAMES.TITLE, propsList)
	    };
	};
	
	var rafPolyfill = function () {
	    var clock = Date.now();
	
	    return function (callback) {
	        var currentTime = Date.now();
	
	        if (currentTime - clock > 16) {
	            clock = currentTime;
	            callback(currentTime);
	        } else {
	            setTimeout(function () {
	                rafPolyfill(callback);
	            }, 0);
	        }
	    };
	}();
	
	var cafPolyfill = function cafPolyfill(id) {
	    return clearTimeout(id);
	};
	
	var requestAnimationFrame = typeof window !== "undefined" ? window.requestAnimationFrame || window.webkitRequestAnimationFrame || window.mozRequestAnimationFrame || rafPolyfill : global.requestAnimationFrame || rafPolyfill;
	
	var cancelAnimationFrame = typeof window !== "undefined" ? window.cancelAnimationFrame || window.webkitCancelAnimationFrame || window.mozCancelAnimationFrame || cafPolyfill : global.cancelAnimationFrame || cafPolyfill;
	
	var warn = function warn(msg) {
	    return console && typeof console.warn === "function" && console.warn(msg);
	};
	
	var _helmetCallback = null;
	
	var handleClientStateChange = function handleClientStateChange(newState) {
	    if (_helmetCallback) {
	        cancelAnimationFrame(_helmetCallback);
	    }
	
	    if (newState.defer) {
	        _helmetCallback = requestAnimationFrame(function () {
	            commitTagChanges(newState, function () {
	                _helmetCallback = null;
	            });
	        });
	    } else {
	        commitTagChanges(newState);
	        _helmetCallback = null;
	    }
	};
	
	var commitTagChanges = function commitTagChanges(newState, cb) {
	    var baseTag = newState.baseTag,
	        bodyAttributes = newState.bodyAttributes,
	        htmlAttributes = newState.htmlAttributes,
	        linkTags = newState.linkTags,
	        metaTags = newState.metaTags,
	        noscriptTags = newState.noscriptTags,
	        onChangeClientState = newState.onChangeClientState,
	        scriptTags = newState.scriptTags,
	        styleTags = newState.styleTags,
	        title = newState.title,
	        titleAttributes = newState.titleAttributes;
	
	    updateAttributes(_HelmetConstants.TAG_NAMES.BODY, bodyAttributes);
	    updateAttributes(_HelmetConstants.TAG_NAMES.HTML, htmlAttributes);
	
	    updateTitle(title, titleAttributes);
	
	    var tagUpdates = {
	        baseTag: updateTags(_HelmetConstants.TAG_NAMES.BASE, baseTag),
	        linkTags: updateTags(_HelmetConstants.TAG_NAMES.LINK, linkTags),
	        metaTags: updateTags(_HelmetConstants.TAG_NAMES.META, metaTags),
	        noscriptTags: updateTags(_HelmetConstants.TAG_NAMES.NOSCRIPT, noscriptTags),
	        scriptTags: updateTags(_HelmetConstants.TAG_NAMES.SCRIPT, scriptTags),
	        styleTags: updateTags(_HelmetConstants.TAG_NAMES.STYLE, styleTags)
	    };
	
	    var addedTags = {};
	    var removedTags = {};
	
	    Object.keys(tagUpdates).forEach(function (tagType) {
	        var _tagUpdates$tagType = tagUpdates[tagType],
	            newTags = _tagUpdates$tagType.newTags,
	            oldTags = _tagUpdates$tagType.oldTags;
	
	
	        if (newTags.length) {
	            addedTags[tagType] = newTags;
	        }
	        if (oldTags.length) {
	            removedTags[tagType] = tagUpdates[tagType].oldTags;
	        }
	    });
	
	    cb && cb();
	
	    onChangeClientState(newState, addedTags, removedTags);
	};
	
	var flattenArray = function flattenArray(possibleArray) {
	    return Array.isArray(possibleArray) ? possibleArray.join("") : possibleArray;
	};
	
	var updateTitle = function updateTitle(title, attributes) {
	    if (typeof title !== "undefined" && document.title !== title) {
	        document.title = flattenArray(title);
	    }
	
	    updateAttributes(_HelmetConstants.TAG_NAMES.TITLE, attributes);
	};
	
	var updateAttributes = function updateAttributes(tagName, attributes) {
	    var elementTag = document.getElementsByTagName(tagName)[0];
	
	    if (!elementTag) {
	        return;
	    }
	
	    var helmetAttributeString = elementTag.getAttribute(_HelmetConstants.HELMET_ATTRIBUTE);
	    var helmetAttributes = helmetAttributeString ? helmetAttributeString.split(",") : [];
	    var attributesToRemove = [].concat(helmetAttributes);
	    var attributeKeys = Object.keys(attributes);
	
	    for (var i = 0; i < attributeKeys.length; i++) {
	        var attribute = attributeKeys[i];
	        var value = attributes[attribute] || "";
	
	        if (elementTag.getAttribute(attribute) !== value) {
	            elementTag.setAttribute(attribute, value);
	        }
	
	        if (helmetAttributes.indexOf(attribute) === -1) {
	            helmetAttributes.push(attribute);
	        }
	
	        var indexToSave = attributesToRemove.indexOf(attribute);
	        if (indexToSave !== -1) {
	            attributesToRemove.splice(indexToSave, 1);
	        }
	    }
	
	    for (var _i = attributesToRemove.length - 1; _i >= 0; _i--) {
	        elementTag.removeAttribute(attributesToRemove[_i]);
	    }
	
	    if (helmetAttributes.length === attributesToRemove.length) {
	        elementTag.removeAttribute(_HelmetConstants.HELMET_ATTRIBUTE);
	    } else if (elementTag.getAttribute(_HelmetConstants.HELMET_ATTRIBUTE) !== attributeKeys.join(",")) {
	        elementTag.setAttribute(_HelmetConstants.HELMET_ATTRIBUTE, attributeKeys.join(","));
	    }
	};
	
	var updateTags = function updateTags(type, tags) {
	    var headElement = document.head || document.querySelector(_HelmetConstants.TAG_NAMES.HEAD);
	    var tagNodes = headElement.querySelectorAll(type + "[" + _HelmetConstants.HELMET_ATTRIBUTE + "]");
	    var oldTags = Array.prototype.slice.call(tagNodes);
	    var newTags = [];
	    var indexToDelete = void 0;
	
	    if (tags && tags.length) {
	        tags.forEach(function (tag) {
	            var newElement = document.createElement(type);
	
	            for (var attribute in tag) {
	                if (tag.hasOwnProperty(attribute)) {
	                    if (attribute === _HelmetConstants.TAG_PROPERTIES.INNER_HTML) {
	                        newElement.innerHTML = tag.innerHTML;
	                    } else if (attribute === _HelmetConstants.TAG_PROPERTIES.CSS_TEXT) {
	                        if (newElement.styleSheet) {
	                            newElement.styleSheet.cssText = tag.cssText;
	                        } else {
	                            newElement.appendChild(document.createTextNode(tag.cssText));
	                        }
	                    } else {
	                        var value = typeof tag[attribute] === "undefined" ? "" : tag[attribute];
	                        newElement.setAttribute(attribute, value);
	                    }
	                }
	            }
	
	            newElement.setAttribute(_HelmetConstants.HELMET_ATTRIBUTE, "true");
	
	            // Remove a duplicate tag from domTagstoRemove, so it isn't cleared.
	            if (oldTags.some(function (existingTag, index) {
	                indexToDelete = index;
	                return newElement.isEqualNode(existingTag);
	            })) {
	                oldTags.splice(indexToDelete, 1);
	            } else {
	                newTags.push(newElement);
	            }
	        });
	    }
	
	    oldTags.forEach(function (tag) {
	        return tag.parentNode.removeChild(tag);
	    });
	    newTags.forEach(function (tag) {
	        return headElement.appendChild(tag);
	    });
	
	    return {
	        oldTags: oldTags,
	        newTags: newTags
	    };
	};
	
	var generateElementAttributesAsString = function generateElementAttributesAsString(attributes) {
	    return Object.keys(attributes).reduce(function (str, key) {
	        var attr = typeof attributes[key] !== "undefined" ? key + "=\"" + attributes[key] + "\"" : "" + key;
	        return str ? str + " " + attr : attr;
	    }, "");
	};
	
	var generateTitleAsString = function generateTitleAsString(type, title, attributes, encode) {
	    var attributeString = generateElementAttributesAsString(attributes);
	    var flattenedTitle = flattenArray(title);
	    return attributeString ? "<" + type + " " + _HelmetConstants.HELMET_ATTRIBUTE + "=\"true\" " + attributeString + ">" + encodeSpecialCharacters(flattenedTitle, encode) + "</" + type + ">" : "<" + type + " " + _HelmetConstants.HELMET_ATTRIBUTE + "=\"true\">" + encodeSpecialCharacters(flattenedTitle, encode) + "</" + type + ">";
	};
	
	var generateTagsAsString = function generateTagsAsString(type, tags, encode) {
	    return tags.reduce(function (str, tag) {
	        var attributeHtml = Object.keys(tag).filter(function (attribute) {
	            return !(attribute === _HelmetConstants.TAG_PROPERTIES.INNER_HTML || attribute === _HelmetConstants.TAG_PROPERTIES.CSS_TEXT);
	        }).reduce(function (string, attribute) {
	            var attr = typeof tag[attribute] === "undefined" ? attribute : attribute + "=\"" + encodeSpecialCharacters(tag[attribute], encode) + "\"";
	            return string ? string + " " + attr : attr;
	        }, "");
	
	        var tagContent = tag.innerHTML || tag.cssText || "";
	
	        var isSelfClosing = _HelmetConstants.SELF_CLOSING_TAGS.indexOf(type) === -1;
	
	        return str + "<" + type + " " + _HelmetConstants.HELMET_ATTRIBUTE + "=\"true\" " + attributeHtml + (isSelfClosing ? "/>" : ">" + tagContent + "</" + type + ">");
	    }, "");
	};
	
	var convertElementAttributestoReactProps = function convertElementAttributestoReactProps(attributes) {
	    var initProps = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	    return Object.keys(attributes).reduce(function (obj, key) {
	        obj[_HelmetConstants.REACT_TAG_MAP[key] || key] = attributes[key];
	        return obj;
	    }, initProps);
	};
	
	var convertReactPropstoHtmlAttributes = function convertReactPropstoHtmlAttributes(props) {
	    var initAttributes = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	    return Object.keys(props).reduce(function (obj, key) {
	        obj[_HelmetConstants.HTML_TAG_MAP[key] || key] = props[key];
	        return obj;
	    }, initAttributes);
	};
	
	var generateTitleAsReactComponent = function generateTitleAsReactComponent(type, title, attributes) {
	    var _initProps;
	
	    // assigning into an array to define toString function on it
	    var initProps = (_initProps = {
	        key: title
	    }, _initProps[_HelmetConstants.HELMET_ATTRIBUTE] = true, _initProps);
	    var props = convertElementAttributestoReactProps(attributes, initProps);
	
	    return [_react2.default.createElement(_HelmetConstants.TAG_NAMES.TITLE, props, title)];
	};
	
	var generateTagsAsReactComponent = function generateTagsAsReactComponent(type, tags) {
	    return tags.map(function (tag, i) {
	        var _mappedTag;
	
	        var mappedTag = (_mappedTag = {
	            key: i
	        }, _mappedTag[_HelmetConstants.HELMET_ATTRIBUTE] = true, _mappedTag);
	
	        Object.keys(tag).forEach(function (attribute) {
	            var mappedAttribute = _HelmetConstants.REACT_TAG_MAP[attribute] || attribute;
	
	            if (mappedAttribute === _HelmetConstants.TAG_PROPERTIES.INNER_HTML || mappedAttribute === _HelmetConstants.TAG_PROPERTIES.CSS_TEXT) {
	                var content = tag.innerHTML || tag.cssText;
	                mappedTag.dangerouslySetInnerHTML = { __html: content };
	            } else {
	                mappedTag[mappedAttribute] = tag[attribute];
	            }
	        });
	
	        return _react2.default.createElement(type, mappedTag);
	    });
	};
	
	var getMethodsForTag = function getMethodsForTag(type, tags, encode) {
	    switch (type) {
	        case _HelmetConstants.TAG_NAMES.TITLE:
	            return {
	                toComponent: function toComponent() {
	                    return generateTitleAsReactComponent(type, tags.title, tags.titleAttributes, encode);
	                },
	                toString: function toString() {
	                    return generateTitleAsString(type, tags.title, tags.titleAttributes, encode);
	                }
	            };
	        case _HelmetConstants.ATTRIBUTE_NAMES.BODY:
	        case _HelmetConstants.ATTRIBUTE_NAMES.HTML:
	            return {
	                toComponent: function toComponent() {
	                    return convertElementAttributestoReactProps(tags);
	                },
	                toString: function toString() {
	                    return generateElementAttributesAsString(tags);
	                }
	            };
	        default:
	            return {
	                toComponent: function toComponent() {
	                    return generateTagsAsReactComponent(type, tags);
	                },
	                toString: function toString() {
	                    return generateTagsAsString(type, tags, encode);
	                }
	            };
	    }
	};
	
	var mapStateOnServer = function mapStateOnServer(_ref) {
	    var baseTag = _ref.baseTag,
	        bodyAttributes = _ref.bodyAttributes,
	        encode = _ref.encode,
	        htmlAttributes = _ref.htmlAttributes,
	        linkTags = _ref.linkTags,
	        metaTags = _ref.metaTags,
	        noscriptTags = _ref.noscriptTags,
	        scriptTags = _ref.scriptTags,
	        styleTags = _ref.styleTags,
	        _ref$title = _ref.title,
	        title = _ref$title === undefined ? "" : _ref$title,
	        titleAttributes = _ref.titleAttributes;
	    return {
	        base: getMethodsForTag(_HelmetConstants.TAG_NAMES.BASE, baseTag, encode),
	        bodyAttributes: getMethodsForTag(_HelmetConstants.ATTRIBUTE_NAMES.BODY, bodyAttributes, encode),
	        htmlAttributes: getMethodsForTag(_HelmetConstants.ATTRIBUTE_NAMES.HTML, htmlAttributes, encode),
	        link: getMethodsForTag(_HelmetConstants.TAG_NAMES.LINK, linkTags, encode),
	        meta: getMethodsForTag(_HelmetConstants.TAG_NAMES.META, metaTags, encode),
	        noscript: getMethodsForTag(_HelmetConstants.TAG_NAMES.NOSCRIPT, noscriptTags, encode),
	        script: getMethodsForTag(_HelmetConstants.TAG_NAMES.SCRIPT, scriptTags, encode),
	        style: getMethodsForTag(_HelmetConstants.TAG_NAMES.STYLE, styleTags, encode),
	        title: getMethodsForTag(_HelmetConstants.TAG_NAMES.TITLE, { title: title, titleAttributes: titleAttributes }, encode)
	    };
	};
	
	exports.convertReactPropstoHtmlAttributes = convertReactPropstoHtmlAttributes;
	exports.handleClientStateChange = handleClientStateChange;
	exports.mapStateOnServer = mapStateOnServer;
	exports.reducePropsToState = reducePropsToState;
	exports.requestAnimationFrame = requestAnimationFrame;
	exports.warn = warn;
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),

/***/ 82:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }
	
	var React = __webpack_require__(2);
	var React__default = _interopDefault(React);
	var ExecutionEnvironment = _interopDefault(__webpack_require__(72));
	var shallowEqual = _interopDefault(__webpack_require__(85));
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function withSideEffect(reducePropsToState, handleStateChangeOnClient, mapStateOnServer) {
	  if (typeof reducePropsToState !== 'function') {
	    throw new Error('Expected reducePropsToState to be a function.');
	  }
	  if (typeof handleStateChangeOnClient !== 'function') {
	    throw new Error('Expected handleStateChangeOnClient to be a function.');
	  }
	  if (typeof mapStateOnServer !== 'undefined' && typeof mapStateOnServer !== 'function') {
	    throw new Error('Expected mapStateOnServer to either be undefined or a function.');
	  }
	
	  function getDisplayName(WrappedComponent) {
	    return WrappedComponent.displayName || WrappedComponent.name || 'Component';
	  }
	
	  return function wrap(WrappedComponent) {
	    if (typeof WrappedComponent !== 'function') {
	      throw new Error('Expected WrappedComponent to be a React component.');
	    }
	
	    var mountedInstances = [];
	    var state = void 0;
	
	    function emitChange() {
	      state = reducePropsToState(mountedInstances.map(function (instance) {
	        return instance.props;
	      }));
	
	      if (SideEffect.canUseDOM) {
	        handleStateChangeOnClient(state);
	      } else if (mapStateOnServer) {
	        state = mapStateOnServer(state);
	      }
	    }
	
	    var SideEffect = function (_Component) {
	      _inherits(SideEffect, _Component);
	
	      function SideEffect() {
	        _classCallCheck(this, SideEffect);
	
	        return _possibleConstructorReturn(this, _Component.apply(this, arguments));
	      }
	
	      // Try to use displayName of wrapped component
	      SideEffect.peek = function peek() {
	        return state;
	      };
	
	      // Expose canUseDOM so tests can monkeypatch it
	
	
	      SideEffect.rewind = function rewind() {
	        if (SideEffect.canUseDOM) {
	          throw new Error('You may only call rewind() on the server. Call peek() to read the current state.');
	        }
	
	        var recordedState = state;
	        state = undefined;
	        mountedInstances = [];
	        return recordedState;
	      };
	
	      SideEffect.prototype.shouldComponentUpdate = function shouldComponentUpdate(nextProps) {
	        return !shallowEqual(nextProps, this.props);
	      };
	
	      SideEffect.prototype.componentWillMount = function componentWillMount() {
	        mountedInstances.push(this);
	        emitChange();
	      };
	
	      SideEffect.prototype.componentDidUpdate = function componentDidUpdate() {
	        emitChange();
	      };
	
	      SideEffect.prototype.componentWillUnmount = function componentWillUnmount() {
	        var index = mountedInstances.indexOf(this);
	        mountedInstances.splice(index, 1);
	        emitChange();
	      };
	
	      SideEffect.prototype.render = function render() {
	        return React__default.createElement(WrappedComponent, this.props);
	      };
	
	      return SideEffect;
	    }(React.Component);
	
	    SideEffect.displayName = 'SideEffect(' + getDisplayName(WrappedComponent) + ')';
	    SideEffect.canUseDOM = ExecutionEnvironment.canUseDOM;
	
	
	    return SideEffect;
	  };
	}
	
	module.exports = withSideEffect;


/***/ }),

/***/ 85:
/***/ (function(module, exports) {

	//
	
	module.exports = function shallowEqual(objA, objB, compare, compareContext) {
	  var ret = compare ? compare.call(compareContext, objA, objB) : void 0;
	
	  if (ret !== void 0) {
	    return !!ret;
	  }
	
	  if (objA === objB) {
	    return true;
	  }
	
	  if (typeof objA !== "object" || !objA || typeof objB !== "object" || !objB) {
	    return false;
	  }
	
	  var keysA = Object.keys(objA);
	  var keysB = Object.keys(objB);
	
	  if (keysA.length !== keysB.length) {
	    return false;
	  }
	
	  var bHasOwnProperty = Object.prototype.hasOwnProperty.bind(objB);
	
	  // Test for A's keys different from B.
	  for (var idx = 0; idx < keysA.length; idx++) {
	    var key = keysA[idx];
	
	    if (!bHasOwnProperty(key)) {
	      return false;
	    }
	
	    var valueA = objA[key];
	    var valueB = objB[key];
	
	    ret = compare ? compare.call(compareContext, valueA, valueB, key) : void 0;
	
	    if (ret === false || (ret === void 0 && valueA !== valueB)) {
	      return false;
	    }
	  }
	
	  return true;
	};


/***/ }),

/***/ 276:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(12);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _emotion = __webpack_require__(5);
	
	var _reactEmotion = __webpack_require__(3);
	
	var _reactEmotion2 = _interopRequireDefault(_reactEmotion);
	
	var _section = __webpack_require__(11);
	
	var _section2 = _interopRequireDefault(_section);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var FooterClass = /*#__PURE__*/(0, _emotion.css)('clear:both;background-color:#00b386;display:flex;flex-direction:column-reverse;padding-bottom:10rem;padding-top:3rem;@media (min-width:767px){flex-direction:row;}');
	
	var Nav = /*#__PURE__*/(0, _reactEmotion2.default)('div', {
	  target: 'e1r41jcc0'
	})('display:flex;flex-direction:row;position:relative;z-index:1;border-top:1px solid white;padding-top:1rem;@media (min-width:767px){border-top:none;padding-top:0;}');
	
	var NavList = /*#__PURE__*/(0, _reactEmotion2.default)('ul', {
	  target: 'e1r41jcc1'
	})('list-style:none;padding:0.5rem;font-size:0.7rem;&:last-child{border:none;}@media (min-width:767px){padding:1rem 2rem;border-right:1px solid white;font-size:1rem;}');
	
	var NavListItem = /*#__PURE__*/(0, _reactEmotion2.default)('li', {
	  target: 'e1r41jcc2'
	})('color:white;margin-bottom:1rem;font-weight:300;a{color:white}');
	
	var Footer = function (_React$Component) {
	  _inherits(Footer, _React$Component);
	
	  function Footer() {
	    _classCallCheck(this, Footer);
	
	    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
	  }
	
	  Footer.prototype.shouldComponentUpdate = function shouldComponentUpdate() {
	    return false;
	  };
	
	  Footer.prototype.render = function render() {
	    return _react2.default.createElement(
	      'footer',
	      null,
	      _react2.default.createElement(
	        _section2.default,
	        { className: FooterClass, shading: true },
	        _react2.default.createElement(
	          Nav,
	          null,
	          _react2.default.createElement(
	            NavList,
	            null,
	            _react2.default.createElement(
	              NavListItem,
	              null,
	              _react2.default.createElement(
	                _gatsbyLink2.default,
	                { to: '/#partners' },
	                'Partners'
	              )
	            ),
	            _react2.default.createElement(
	              NavListItem,
	              null,
	              _react2.default.createElement(
	                _gatsbyLink2.default,
	                { to: '/#how-it-works' },
	                'How It Works'
	              )
	            ),
	            _react2.default.createElement(
	              NavListItem,
	              null,
	              _react2.default.createElement(
	                _gatsbyLink2.default,
	                { to: '/#features' },
	                'Features'
	              )
	            ),
	            _react2.default.createElement(
	              NavListItem,
	              null,
	              _react2.default.createElement(
	                _gatsbyLink2.default,
	                { to: '/testimonials' },
	                'Testimonials'
	              )
	            ),
	            _react2.default.createElement(
	              NavListItem,
	              null,
	              _react2.default.createElement(
	                _gatsbyLink2.default,
	                { to: '/press' },
	                'Press'
	              )
	            )
	          ),
	          _react2.default.createElement(
	            NavList,
	            null,
	            _react2.default.createElement(
	              NavListItem,
	              null,
	              _react2.default.createElement(
	                _gatsbyLink2.default,
	                { to: '/blog' },
	                'Blog'
	              )
	            ),
	            _react2.default.createElement(
	              NavListItem,
	              null,
	              _react2.default.createElement(
	                _gatsbyLink2.default,
	                { to: '/tos' },
	                'Terms of Use'
	              )
	            ),
	            _react2.default.createElement(
	              NavListItem,
	              null,
	              _react2.default.createElement(
	                _gatsbyLink2.default,
	                { to: '/privacy' },
	                'Privacy Policy'
	              )
	            )
	          ),
	          _react2.default.createElement(
	            NavList,
	            null,
	            _react2.default.createElement(
	              NavListItem,
	              null,
	              'Contact'
	            ),
	            _react2.default.createElement(
	              NavListItem,
	              null,
	              'sales@trywhistle.com'
	            ),
	            _react2.default.createElement(
	              NavListItem,
	              null,
	              _react2.default.createElement('div', { className: 'fb-messengermessageus',
	                'data-messenger_app_id': ("822067874560098"),
	                'data-page_id': ("718319861593356"),
	                'data-color': 'white',
	                'data-size': 'standard' })
	            ),
	            _react2.default.createElement(
	              NavListItem,
	              null,
	              _react2.default.createElement('div', { className: 'fb-like', 'data-href': 'https://www.facebook.com/trywhistle',
	                'data-width': '79', 'data-layout': 'button_count', 'data-action': 'like', 'data-size': 'small',
	                'data-share': 'false' })
	            ),
	            _react2.default.createElement(
	              NavListItem,
	              null,
	              _react2.default.createElement(
	                'div',
	                null,
	                _react2.default.createElement('script', { type: 'IN/FollowCompany', 'data-id': '4797522', 'data-counter': 'right' })
	              )
	            )
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          null,
	          _react2.default.createElement('div', { id: 'htr-widget-container-513' })
	        )
	      )
	    );
	  };
	
	  return Footer;
	}(_react2.default.Component);
	
	exports.default = Footer;
	module.exports = exports['default'];

/***/ }),

/***/ 277:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(12);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _reactEmotion = __webpack_require__(3);
	
	var _reactEmotion2 = _interopRequireDefault(_reactEmotion);
	
	var _emotion = __webpack_require__(5);
	
	var _lodash = __webpack_require__(32);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _logo = __webpack_require__(282);
	
	var _logo2 = _interopRequireDefault(_logo);
	
	var _Navigation = __webpack_require__(281);
	
	var _Navigation2 = _interopRequireDefault(_Navigation);
	
	var _MobileNav = __webpack_require__(279);
	
	var _MobileNav2 = _interopRequireDefault(_MobileNav);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var HeaderClass = /*#__PURE__*/(0, _emotion.css)('height:5rem;position:fixed;top:0;left:0;right:0;box-shadow:0 1px 4px rgba(53,57,71,.3);background-color:#fff;display:flex;padding:0 2rem;z-index:100;@media (min-width:776px){padding:0 3.1rem;}');
	var LogoContainer = /*#__PURE__*/(0, _reactEmotion2.default)('div', {
		target: 'elye7m40'
	})('flex:1;display:flex;align-items:center;');
	var LogoWrapper = /*#__PURE__*/(0, _reactEmotion2.default)('div', {
		target: 'elye7m41'
	})('width:6rem;padding:1rem 0;display:inline-block;position:relative;z-index:100;');
	
	// @media (min-width: 1025px) {
	// 	width: 13rem;
	// 	padding: 1rem 2.5rem;
	// }
	
	var NavigationWrapper = /*#__PURE__*/(0, _reactEmotion2.default)('nav', {
		target: 'elye7m42'
	})('display:none;@media (min-width:1025px){display:flex;}');
	
	var MobileNavWrapper = /*#__PURE__*/(0, _reactEmotion2.default)('div', {
		target: 'elye7m43'
	})('display:flex;align-items:center;@media (min-width:1025px){display:none;}');
	
	var Text = /*#__PURE__*/(0, _reactEmotion2.default)('h3', {
		target: 'elye7m44'
	})('font-weight:200;margin-bottom:0;margin-left:1rem;font-style:italic;margin-top:1rem;@media (min-width:800px){margin-top:0;}@media (min-width:1200px){margin-top:1rem;}');
	
	var buildLinks = function buildLinks(data) {
		var links = [{
			label: 'Get Started',
			links: [{ to: '/schedule', label: 'Schedule a Demo' }, { to: 'https://app.trywhistle.com/register?source=whistle-marketing', label: 'Try it Free', external: true }]
	
		}, { label: 'Integrations & Partners',
			links: [{ to: '/cloudbeds', label: 'Cloudbeds' }]
		}, { to: '/#how-it-works', label: 'How It Works' }, { to: '/#features', label: 'Features' }, {
			label: 'Hotels & Customers',
			links: [{ to: '/testimonials', label: 'Testimonials' }, { to: '/hilton', label: 'Hilton' }, { to: '/ihg', label: 'IHG' }, { to: '/choice', label: 'Choice' }, { to: '/independent', label: 'Independent' }]
		}, {
			label: 'Company',
			links: [{ to: '/about', label: 'About Us' }, { to: '/press', label: 'Press' }, { to: '/blog', label: 'Blog' }]
		}, {
			label: 'Login',
			external: true,
			button: true,
			to: 'https://app.trywhistle.com/login'
		}];
		console.log("DATA", data);
		data.edges.map(function (d) {
			var _ref = _lodash2.default.get(d, ['node', 'frontmatter']) || {},
			    label = _ref.label,
			    title = _ref.title;
	
			var partner = {
				to: '/' + title,
				label: label
			};
			links[1].links.push(partner);
		});
		return links;
	};
	
	var Header = function Header(props) {
		var links = buildLinks(props);
	
		return _react2.default.createElement(
			'header',
			{ className: HeaderClass },
			_react2.default.createElement(
				LogoContainer,
				null,
				_react2.default.createElement(
					LogoWrapper,
					null,
					_react2.default.createElement(
						_gatsbyLink2.default,
						{ to: '/' },
						_react2.default.createElement(_logo2.default, null)
					)
				),
				_react2.default.createElement(
					Text,
					null,
					'"At your service."'
				)
			),
			_react2.default.createElement(
				NavigationWrapper,
				null,
				_react2.default.createElement(_Navigation2.default, { links: links })
			),
			_react2.default.createElement(
				MobileNavWrapper,
				null,
				_react2.default.createElement(_MobileNav2.default, { links: links })
			)
		);
	};
	
	exports.default = Header;
	module.exports = exports['default'];

/***/ }),

/***/ 278:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactEmotion = __webpack_require__(3);
	
	var _reactEmotion2 = _interopRequireDefault(_reactEmotion);
	
	var _emotion = __webpack_require__(5);
	
	var _Button = __webpack_require__(13);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var NavItem = /*#__PURE__*/(0, _reactEmotion2.default)('li', {
	  target: 'e13h5kfs0'
	})('list-style:none;text-align:left;margin-top:-1px;padding:0rem 1rem;border-bottom:1px solid #F8F8F8;background:#fff;&:last-child,&:first-child{border:none;padding:0.4rem 1rem;}a{display:block;}@media (min-width:800px){text-align:center;}');
	
	var DropdownNavClass = /*#__PURE__*/(0, _emotion.css)('@media (min-width:800px){pointer-events:none;transition:.2s ease-out;opacity:0;box-shadow:0 1px 4px rgba(53,57,71,.3);position:absolute;display:flex;flex-direction:column;align-items:flex-start;min-width:300px;right:-50px;top:3.3rem;}');
	
	var Chevron = /*#__PURE__*/(0, _reactEmotion2.default)('div', {
	  target: 'e13h5kfs1'
	})('position:absolute;right:15px;&.flipped{-webkit-transform:rotate(180deg);-moz-transform:rotate(180deg);-o-transform:rotate(180deg);-ms-transform:rotate(180deg);transform:rotate(180deg);}');
	
	var IconClass = /*#__PURE__*/(0, _emotion.css)('color:black;');
	
	var Wrapper = /*#__PURE__*/(0, _reactEmotion2.default)('div', {
	  target: 'e13h5kfs2'
	})('position:relative;display:flex;justify-content:space-between;align-items:flex-start;flex-direction:column;width:100%;&:hover,&:focus{.', DropdownNavClass, '{pointer-events:all;opacity:1;}}');
	
	var SubContainer = /*#__PURE__*/(0, _reactEmotion2.default)('div', {
	  target: 'e13h5kfs3'
	})();
	
	var MobileDropdown = function (_React$Component) {
	  _inherits(MobileDropdown, _React$Component);
	
	  function MobileDropdown(props) {
	    _classCallCheck(this, MobileDropdown);
	
	    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props));
	
	    _this.state = {
	      toggled: false
	    };
	    return _this;
	  }
	
	  MobileDropdown.prototype.toggle = function toggle() {
	    if (this.props.nav.links) {
	      this.setState({ toggled: !this.state.toggled });
	    }
	  };
	
	  MobileDropdown.prototype.renderLinks = function renderLinks(links) {
	    var _this2 = this;
	
	    return _react2.default.createElement(
	      SubContainer,
	      null,
	      links.map(function (link, idx) {
	        return _react2.default.createElement(
	          NavItem,
	          { key: idx },
	          _react2.default.createElement(
	            _Button2.default,
	            {
	              anchor: true,
	              navLink: true,
	              to: link.to,
	              external: link.external,
	              icon: 'arrow_right_alt',
	              onClick: function onClick() {
	                return _this2.props.onNavigate && _this2.props.onNavigate();
	              }
	            },
	            link.label
	          )
	        );
	      })
	    );
	  };
	
	  MobileDropdown.prototype.render = function render() {
	    var _this3 = this;
	
	    var _props$nav = this.props.nav,
	        label = _props$nav.label,
	        links = _props$nav.links;
	
	    return _react2.default.createElement(
	      Wrapper,
	      { onClick: function onClick() {
	          return _this3.toggle();
	        } },
	      _react2.default.createElement(
	        _Button2.default,
	        { anchor: true, navLink: true, to: '#', icon: links.length },
	        label,
	        links ? _react2.default.createElement(
	          Chevron,
	          { className: this.state.toggled ? 'flipped' : '' },
	          _react2.default.createElement(
	            'i',
	            { className: IconClass + ' material-icons' },
	            'expand_more'
	          )
	        ) : null
	      ),
	      _react2.default.createElement(
	        'nav',
	        { className: DropdownNavClass },
	        this.state.toggled ? this.renderLinks(links) : null
	      )
	    );
	  };
	
	  return MobileDropdown;
	}(_react2.default.Component);
	
	exports.default = MobileDropdown;
	module.exports = exports['default'];

/***/ }),

/***/ 279:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactEmotion = __webpack_require__(3);
	
	var _reactEmotion2 = _interopRequireDefault(_reactEmotion);
	
	var _emotion = __webpack_require__(5);
	
	__webpack_require__(402);
	
	var _Button = __webpack_require__(13);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	var _MobileDropdown = __webpack_require__(278);
	
	var _MobileDropdown2 = _interopRequireDefault(_MobileDropdown);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var MobileNavClass = /*#__PURE__*/(0, _emotion.css)('color:#232323;');
	
	var NavClass = /*#__PURE__*/(0, _emotion.css)('transition:.25s ease-out;position:absolute;left:0;top:5rem;right:0;box-shadow:0 2px 4px rgba(0,0,0,0.15);height:0;z-index:0;transform:translateY(-1300px);&.is-active{height:calc(100vh - 80px);overflow-y:scroll;transform:translateY(0);}');
	
	var ButtonContainer = /*#__PURE__*/(0, _reactEmotion2.default)('div', {
	  target: 'e181jo400'
	})('display:flex;justify-content:center;');
	
	var MobileNavClassMenu = /*#__PURE__*/(0, _emotion.css)('position:relative;z-index:100;');
	
	var NavItem = /*#__PURE__*/(0, _reactEmotion2.default)('li', {
	  target: 'e181jo401'
	})('text-align:left;padding:0.4rem 1rem;border-bottom:1px solid #F8F8F8;background:#fff;&:last-child{border:none;padding:2rem;}@media (min-width:800px){padding:1rem;text-align:center;}');
	
	// {props.links.map(link => (
	//   <li key={link.to}>
	//     <Button anchor navLink to={link.to}>{link.label}</Button>
	//   </li>
	// ))}
	
	var MobileNav = function (_React$Component) {
	  _inherits(MobileNav, _React$Component);
	
	  function MobileNav(props) {
	    _classCallCheck(this, MobileNav);
	
	    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props));
	
	    _this.state = {
	      isOpen: false,
	      toggled: {}
	    };
	
	    _this.handleClickOutside = _this.handleClickOutside.bind(_this);
	    return _this;
	  }
	
	  MobileNav.prototype.componentDidMount = function componentDidMount() {
	    document.addEventListener('mousedown', this.handleClickOutside);
	  };
	
	  MobileNav.prototype.componentWillUnmount = function componentWillUnmount() {
	    document.removeEventListener('mousedown', this.handleClickOutside);
	  };
	
	  MobileNav.prototype.handleClickOutside = function handleClickOutside(event) {
	    if (this.wrapperRef && !this.wrapperRef.contains(event.target) && !this.menuRef.contains(event.target)) {
	      this.setState({ isOpen: false });
	    }
	  };
	
	  MobileNav.prototype.toggleNav = function toggleNav() {
	    this.setState({ isOpen: !this.state.isOpen });
	  };
	
	  MobileNav.prototype.render = function render() {
	    var _this2 = this;
	
	    return _react2.default.createElement(
	      'div',
	      { className: MobileNavClass },
	      _react2.default.createElement(
	        'button',
	        { ref: function ref(_ref) {
	            _this2.menuRef = _ref;
	          }, onClick: function onClick() {
	            return _this2.toggleNav();
	          }, className: MobileNavClassMenu + ' hamburger hamburger--spin ' + (this.state.isOpen ? 'is-active' : ''), type: 'button' },
	        _react2.default.createElement(
	          'span',
	          { className: 'hamburger-box' },
	          _react2.default.createElement('span', { className: 'hamburger-inner' })
	        )
	      ),
	      _react2.default.createElement(
	        'ul',
	        { ref: function ref(_ref2) {
	            _this2.wrapperRef = _ref2;
	          }, className: NavClass + ' ' + (this.state.isOpen ? 'is-active' : '') },
	        this.props.links.map(function (link, idx) {
	          if (link.links) {
	            return _react2.default.createElement(
	              NavItem,
	              { key: idx },
	              _react2.default.createElement(_MobileDropdown2.default, {
	                key: link.label,
	                nav: link,
	                onNavigate: function onNavigate() {
	                  return _this2.toggleNav();
	                }
	              })
	            );
	          } else if (link.button) {
	            return null;
	          } else {
	            return _react2.default.createElement(
	              NavItem,
	              { key: idx },
	              _react2.default.createElement(
	                _Button2.default,
	                { mobile: true, anchor: true, navLink: true, to: link.to, onClick: function onClick() {
	                    return _this2.toggleNav();
	                  } },
	                link.label
	              )
	            );
	          }
	        }),
	        _react2.default.createElement(
	          NavItem,
	          null,
	          _react2.default.createElement(
	            ButtonContainer,
	            null,
	            _react2.default.createElement(
	              _Button2.default,
	              { to: 'https://app.trywhistle.com/login', flat: true, horizontalPadding: true, external: true },
	              'Login'
	            )
	          )
	        )
	      )
	    );
	  };
	
	  return MobileNav;
	}(_react2.default.Component);
	
	exports.default = MobileNav;
	module.exports = exports['default'];

/***/ }),

/***/ 280:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactEmotion = __webpack_require__(3);
	
	var _reactEmotion2 = _interopRequireDefault(_reactEmotion);
	
	var _emotion = __webpack_require__(5);
	
	var _Button = __webpack_require__(13);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var NavItem = /*#__PURE__*/(0, _reactEmotion2.default)('li', {
	  target: 'ejh78qy0'
	})('list-style:none;text-align:left;border-bottom:1px solid #F8F8F8;background:#fff;&:last-child,&:first-child{border:none;}a{display:block;margin:0;border-radius:0;}@media (min-width:800px){text-align:center;}');
	
	var DropdownNavClass = /*#__PURE__*/(0, _emotion.css)('@media (min-width:800px){pointer-events:none;transition:.2s ease-out;opacity:0;box-shadow:0 1px 4px rgba(53,57,71,.3);position:absolute;display:flex;flex-direction:column;min-width:300px;right:-50px;top:3.3rem;}');
	
	var Wrapper = /*#__PURE__*/(0, _reactEmotion2.default)('div', {
	  target: 'ejh78qy1'
	})('position:relative;&:hover,&:focus{.', DropdownNavClass, '{pointer-events:all;opacity:1;}}');
	
	var NavDropdown = function (_React$Component) {
	  _inherits(NavDropdown, _React$Component);
	
	  function NavDropdown(props) {
	    _classCallCheck(this, NavDropdown);
	
	    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props));
	
	    _this.state = {};
	    return _this;
	  }
	
	  NavDropdown.prototype.render = function render() {
	    var _this2 = this;
	
	    var _props$nav = this.props.nav,
	        label = _props$nav.label,
	        links = _props$nav.links;
	
	    return _react2.default.createElement(
	      Wrapper,
	      null,
	      _react2.default.createElement(
	        _Button2.default,
	        { anchor: true, navLink: true, to: '#' },
	        label
	      ),
	      _react2.default.createElement(
	        'nav',
	        { className: DropdownNavClass },
	        links.map(function (link, idx) {
	          return _react2.default.createElement(
	            NavItem,
	            { key: idx },
	            _react2.default.createElement(
	              _Button2.default,
	              {
	                anchor: true,
	                navLink: true,
	                external: link.external,
	                to: link.to,
	                icon: 'arrow_right_alt',
	                onClick: function onClick() {
	                  return _this2.props.onNavigate && _this2.props.onNavigate();
	                }
	              },
	              link.label
	            )
	          );
	        })
	      )
	    );
	  };
	
	  return NavDropdown;
	}(_react2.default.Component);
	
	exports.default = NavDropdown;
	module.exports = exports['default'];

/***/ }),

/***/ 281:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactEmotion = __webpack_require__(3);
	
	var _reactEmotion2 = _interopRequireDefault(_reactEmotion);
	
	var _Button = __webpack_require__(13);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	var _NavDropdown = __webpack_require__(280);
	
	var _NavDropdown2 = _interopRequireDefault(_NavDropdown);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Nav = /*#__PURE__*/(0, _reactEmotion2.default)('ul', {
	  target: 'ezjfsau0'
	})('display:flex;align-items:center;li{display:inline;}');
	
	var Navigation = function Navigation(props) {
	  return _react2.default.createElement(
	    Nav,
	    null,
	    props.links.map(function (link, idx) {
	      if (link.links) {
	        return _react2.default.createElement(
	          'li',
	          { key: idx },
	          _react2.default.createElement(_NavDropdown2.default, { key: link.label, nav: link })
	        );
	      } else {
	        return _react2.default.createElement(
	          'li',
	          { key: idx },
	          _react2.default.createElement(
	            _Button2.default,
	            _extends({ anchor: true, navLink: true }, link),
	            link.label
	          )
	        );
	      }
	    })
	  );
	};
	
	exports.default = Navigation;
	module.exports = exports['default'];

/***/ }),

/***/ 282:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Logo = function Logo() {
	    return _react2.default.createElement(
	        "svg",
	        { height: "3rem", viewBox: "0 0 553 272", version: "1.1", xmlns: "http://www.w3.org/2000/svg" },
	        _react2.default.createElement(
	            "defs",
	            null,
	            _react2.default.createElement("path", { d: "M134.603,0.241 C136.533,0.241 137.498,1.206 136.533,3.136 L103.874,113.171 C103.231,115.103 101.623,116.069 99.372,116.069 L89.075,116.069 C86.822,116.069 85.052,115.265 84.571,113.171 L68.162,34.989 L50.788,113.171 C50.305,115.265 48.535,116.069 46.282,116.069 L35.986,116.069 C33.735,116.069 32.126,115.265 31.482,113.171 L0.434,3.136 C-0.531,1.206 0.113,0.241 2.365,0.241 L17.648,0.241 C19.901,0.241 21.507,1.044 21.99,3.295 L37.435,67.808 L41.94,95.96 L46.443,67.808 L61.888,3.295 C62.369,1.206 63.817,0.241 65.911,0.241 L75.884,0.241 C77.975,0.241 79.422,1.206 79.904,3.295 L94.222,67.808 L98.245,95.96 L103.231,67.808 L119.802,3.295 C120.606,1.206 121.893,0.241 124.147,0.241 L134.603,0.241 Z", id: "path-1" }),
	            _react2.default.createElement("path", { d: "M41.849,33.485 C58.903,33.485 73.222,44.103 73.222,77.563 L73.222,115.852 C73.222,118.103 72.256,119.069 70.003,119.069 L57.134,119.069 C54.88,119.069 53.916,118.103 53.916,115.852 L53.916,77.563 C53.916,52.468 48.285,46.997 39.116,46.997 C26.888,46.997 19.973,54.238 19.973,72.74 L19.973,115.852 C19.973,118.103 19.006,119.069 16.755,119.069 L3.886,119.069 C1.632,119.069 0.667,118.103 0.667,115.852 L0.667,3.241 C0.667,0.99 1.632,0.022 3.886,0.022 L16.755,0.022 C19.006,0.022 19.973,0.99 19.973,3.241 L19.973,45.226 L20.292,45.226 C23.671,39.115 29.946,33.485 41.849,33.485 Z", id: "path-3" }),
	            _react2.default.createElement("path", { d: "M45.136,37.646 C59.131,41.668 63.476,49.389 63.476,61.937 C63.476,79.311 47.709,88 30.016,88 C16.499,88 4.114,84.3 1.057,80.118 C-0.068,78.507 -0.068,77.385 0.895,75.935 L4.273,70.784 C5.077,69.661 7.009,69.98 8.459,70.464 C14.73,72.556 21.166,74.488 29.047,74.488 C42.4,74.488 45.136,68.857 45.136,63.709 C45.136,58.72 41.919,56.629 32.586,53.734 L18.756,49.552 C6.687,45.851 1.701,36.842 1.701,26.226 C1.701,11.425 12.154,0.325 31.785,0.325 C45.458,0.325 56.236,4.667 59.775,8.206 C60.418,8.852 61.382,9.975 59.775,12.388 L56.396,17.537 C55.754,18.984 53.663,18.34 52.213,17.859 C46.421,15.767 40.469,13.838 33.554,13.838 C24.061,13.838 20.038,18.021 20.038,24.294 C20.038,27.996 21.808,30.89 26.314,32.178 L45.136,37.646 Z", id: "path-5" }),
	            _react2.default.createElement("path", { d: "M41.506,21.414 C43.76,21.414 44.723,22.379 44.723,24.632 L44.723,30.907 C44.723,33.158 43.76,34.123 41.506,34.123 L31.372,34.123 L31.372,80.456 C31.372,88.339 35.395,91.556 39.09,91.556 L40.221,91.556 C42.472,91.556 43.435,92.522 43.435,94.773 L43.435,101.852 C43.435,104.103 42.472,105.069 40.221,105.069 L34.27,105.069 C19.79,105.069 12.066,96.867 12.066,79.974 L12.066,34.123 L3.701,34.123 C1.447,34.123 0.484,33.158 0.484,30.907 L0.484,24.632 C0.484,22.379 1.447,21.414 3.701,21.414 L12.066,21.414 L12.066,9.028 C12.066,6.775 13.194,6.615 15.283,5.809 L28.155,0.985 C30.243,0.179 31.372,1.951 31.372,4.202 L31.372,21.414 L41.506,21.414 Z", id: "path-7" }),
	            _react2.default.createElement("path", { d: "M25.53,105.556 C27.781,105.556 28.747,106.522 28.747,108.773 L28.747,115.852 C28.747,118.103 27.781,119.069 25.53,119.069 L22.795,119.069 C8.316,119.069 0.595,110.867 0.595,93.974 L0.595,3.241 C0.595,0.99 1.558,0.022 3.812,0.022 L16.681,0.022 C18.932,0.022 19.897,0.99 19.897,3.241 L19.897,92.846 C19.897,101.857 22.313,105.556 24.402,105.556 L25.53,105.556 Z", id: "path-9" }),
	            _react2.default.createElement("path", { d: "M36.86,13.838 C25.116,13.838 20.934,24.776 19.968,37.486 L44.743,37.486 C49.732,37.486 51.018,36.842 51.018,32.015 C51.018,22.525 45.388,13.838 36.86,13.838 Z M63.405,70.784 L66.781,75.935 C67.747,77.385 67.909,78.669 66.622,80.118 C63.564,83.656 51.821,88 38.147,88 C8.386,88 0.343,67.567 0.343,45.044 C0.343,20.272 9.993,0.325 36.057,0.325 C55.522,0.325 70.482,11.584 70.482,34.911 C70.482,47.301 66.3,50.999 52.949,50.999 L19.968,50.999 C21.255,64.513 26.082,74.488 40.239,74.488 C46.513,74.488 52.627,72.556 59.223,70.464 C62.439,69.498 62.924,70.142 63.405,70.784 Z", id: "path-11" }),
	            _react2.default.createElement("path", { d: "M16.396,0.118 C18.647,0.118 19.612,1.081 19.612,3.334 L19.612,100.852 C19.612,103.103 18.647,104.069 16.396,104.069 L3.526,104.069 C1.272,104.069 0.308,103.103 0.308,100.852 L0.308,24.515 L14.372,24.439 L0.308,13.384 L0.308,3.334 C0.308,1.081 1.272,0.118 3.526,0.118 L16.396,0.118 Z", id: "path-13" }),
	            _react2.default.createElement("path", { d: "M134.772,0.792 C150.465,0.792 163.191,13.515 163.191,29.21 L163.191,94.965 C163.191,110.66 150.465,123.382 134.772,123.382 L86.338,123.382 L122.364,179.474 L50.012,123.382 L28.522,123.382 C12.826,123.382 0.105,110.66 0.105,94.965 L0.105,29.21 C0.105,13.515 12.826,0.792 28.522,0.792 L134.772,0.792 Z", id: "path-15" }),
	            _react2.default.createElement("path", { d: "M16.766,3.863 L10.83,3.863 L10.83,21 L5.936,21 L5.936,3.863 L0,3.863 L0,0 L16.766,0 L16.766,3.863 Z M42.958,0 L42.958,21 L38.644,21 L38.644,8.922 C38.644,8.643 38.651,8.34 38.666,8.014 C38.68,7.687 38.707,7.356 38.745,7.019 L33.142,17.815 C32.968,18.151 32.734,18.406 32.44,18.579 C32.145,18.752 31.81,18.838 31.433,18.838 L30.767,18.838 C30.391,18.838 30.055,18.752 29.761,18.579 C29.467,18.406 29.233,18.151 29.059,17.815 L23.456,6.99 C23.484,7.336 23.509,7.675 23.528,8.007 C23.547,8.338 23.557,8.643 23.557,8.922 L23.557,21 L19.242,21 L19.242,0 L22.978,0 C23.19,0 23.376,0.005 23.535,0.014 C23.695,0.024 23.837,0.053 23.962,0.101 C24.088,0.149 24.201,0.223 24.303,0.324 C24.404,0.425 24.503,0.567 24.599,0.749 L30.029,11.401 C30.222,11.766 30.408,12.146 30.586,12.539 C30.765,12.933 30.936,13.337 31.1,13.75 C31.265,13.327 31.436,12.914 31.614,12.511 C31.793,12.107 31.984,11.723 32.186,11.358 L37.601,0.749 C37.698,0.567 37.797,0.425 37.898,0.324 C38,0.223 38.113,0.149 38.238,0.101 C38.364,0.053 38.506,0.024 38.666,0.014 C38.825,0.005 39.011,0 39.223,0 L42.958,0 Z", id: "path-17" })
	        ),
	        _react2.default.createElement(
	            "g",
	            { id: "Page-1", stroke: "none", strokeWidth: "1", fill: "none", fillRule: "evenodd" },
	            _react2.default.createElement(
	                "g",
	                { id: "WhistleLogoTM-2.59.19-PM" },
	                _react2.default.createElement(
	                    "g",
	                    { id: "Group-3", transform: "translate(0.000000, 154.000000)" },
	                    _react2.default.createElement(
	                        "mask",
	                        { id: "mask-2", fill: "white" },
	                        _react2.default.createElement("use", { xlinkHref: "#path-1" })
	                    ),
	                    _react2.default.createElement("g", { id: "Clip-2" }),
	                    _react2.default.createElement("polygon", { id: "Fill-1", fill: "#1AA97B", mask: "url(#mask-2)", points: "-0.1 116.08 136.94 116.08 136.94 0.16 -0.1 0.16" })
	                ),
	                _react2.default.createElement(
	                    "g",
	                    { id: "Group-6", transform: "translate(146.000000, 151.000000)" },
	                    _react2.default.createElement(
	                        "mask",
	                        { id: "mask-4", fill: "white" },
	                        _react2.default.createElement("use", { xlinkHref: "#path-3" })
	                    ),
	                    _react2.default.createElement("g", { id: "Clip-5" }),
	                    _react2.default.createElement("polygon", { id: "Fill-4", fill: "#1AA97B", mask: "url(#mask-4)", points: "0.66 119.08 73.26 119.08 73.26 -0.08 0.66 -0.08" })
	                ),
	                _react2.default.createElement(
	                    "g",
	                    { id: "Group-9", transform: "translate(269.000000, 184.000000)" },
	                    _react2.default.createElement(
	                        "mask",
	                        { id: "mask-6", fill: "white" },
	                        _react2.default.createElement("use", { xlinkHref: "#path-5" })
	                    ),
	                    _react2.default.createElement("g", { id: "Clip-8" }),
	                    _react2.default.createElement("polygon", { id: "Fill-7", fill: "#1AA97B", mask: "url(#mask-6)", points: "0.18 88 63.54 88 63.54 0.28 0.18 0.28" })
	                ),
	                _react2.default.createElement(
	                    "g",
	                    { id: "Group-12", transform: "translate(341.000000, 165.000000)" },
	                    _react2.default.createElement(
	                        "mask",
	                        { id: "mask-8", fill: "white" },
	                        _react2.default.createElement("use", { xlinkHref: "#path-7" })
	                    ),
	                    _react2.default.createElement("g", { id: "Clip-11" }),
	                    _react2.default.createElement("polygon", { id: "Fill-10", fill: "#1AA97B", mask: "url(#mask-8)", points: "0.42 105.08 44.82 105.08 44.82 0.68 0.42 0.68" })
	                ),
	                _react2.default.createElement(
	                    "g",
	                    { id: "Group-15", transform: "translate(398.000000, 151.000000)" },
	                    _react2.default.createElement(
	                        "mask",
	                        { id: "mask-10", fill: "white" },
	                        _react2.default.createElement("use", { xlinkHref: "#path-9" })
	                    ),
	                    _react2.default.createElement("g", { id: "Clip-14" }),
	                    _react2.default.createElement("polygon", { id: "Fill-13", fill: "#1AA97B", mask: "url(#mask-10)", points: "0.54 119.08 28.86 119.08 28.86 -0.08 0.54 -0.08" })
	                ),
	                _react2.default.createElement(
	                    "g",
	                    { id: "Group-18", transform: "translate(433.000000, 184.000000)" },
	                    _react2.default.createElement(
	                        "mask",
	                        { id: "mask-12", fill: "white" },
	                        _react2.default.createElement("use", { xlinkHref: "#path-11" })
	                    ),
	                    _react2.default.createElement("g", { id: "Clip-17" }),
	                    _react2.default.createElement("polygon", { id: "Fill-16", fill: "#1AA97B", mask: "url(#mask-12)", points: "0.34 88 70.54 88 70.54 0.28 0.34 0.28" })
	                ),
	                _react2.default.createElement(
	                    "g",
	                    { id: "Group-21", transform: "translate(235.000000, 166.000000)" },
	                    _react2.default.createElement(
	                        "mask",
	                        { id: "mask-14", fill: "white" },
	                        _react2.default.createElement("use", { xlinkHref: "#path-13" })
	                    ),
	                    _react2.default.createElement("g", { id: "Clip-20" }),
	                    _react2.default.createElement("polygon", { id: "Fill-19", fill: "#1AA97B", mask: "url(#mask-14)", points: "0.22 104.08 19.66 104.08 19.66 0.04 0.22 0.04" })
	                ),
	                _react2.default.createElement(
	                    "g",
	                    { id: "Group-24", transform: "translate(106.000000, 0.000000)" },
	                    _react2.default.createElement(
	                        "mask",
	                        { id: "mask-16", fill: "white" },
	                        _react2.default.createElement("use", { xlinkHref: "#path-15" })
	                    ),
	                    _react2.default.createElement("g", { id: "Clip-23" }),
	                    _react2.default.createElement("polygon", { id: "Fill-22", fill: "#FCC71B", mask: "url(#mask-16)", points: "0.1 179.48 163.3 179.48 163.3 0.68 0.1 0.68" })
	                ),
	                _react2.default.createElement(
	                    "g",
	                    { id: "Group-27", transform: "translate(510.000000, 154.000000)" },
	                    _react2.default.createElement(
	                        "mask",
	                        { id: "mask-18", fill: "white" },
	                        _react2.default.createElement("use", { xlinkHref: "#path-17" })
	                    ),
	                    _react2.default.createElement("g", { id: "Clip-26" }),
	                    _react2.default.createElement("polygon", { id: "Fill-25", fill: "#1AA97B", mask: "url(#mask-18)", points: "-0.1 21.04 42.98 21.04 42.98 -0.08 -0.1 -0.08" })
	                )
	            )
	        )
	    );
	};
	
	exports.default = Logo;
	module.exports = exports["default"];

/***/ }),

/***/ 288:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.query = undefined;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(8);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactHelmet = __webpack_require__(80);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	var _emotion = __webpack_require__(5);
	
	var _reactGa = __webpack_require__(164);
	
	var _reactGa2 = _interopRequireDefault(_reactGa);
	
	var _header = __webpack_require__(277);
	
	var _header2 = _interopRequireDefault(_header);
	
	var _footer = __webpack_require__(276);
	
	var _footer2 = _interopRequireDefault(_footer);
	
	__webpack_require__(825);
	
	var _livechat = __webpack_require__(311);
	
	var _livechat2 = _interopRequireDefault(_livechat);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var ContentClass = /*#__PURE__*/(0, _emotion.css)('margin-top:5.1rem;');
	
	_reactGa2.default.initialize('UA-118290333-1');
	
	var Layout = function Layout(_ref) {
	  var children = _ref.children,
	      data = _ref.data,
	      props = _objectWithoutProperties(_ref, ['children', 'data']);
	
	  var hasFrame = props.location.search.indexOf('frame=true') > -1;
	  if (!hasFrame) {
	    (0, _livechat2.default)(({"GATSBY_LIVE_CHAT_BUCKET":"demo","GATSBY_PLUGINS_SOURCE":"https://plugins-staging.trywhistle.com","GATSBY_FACEBOOK_APPID":"822067874560098","GATSBY_FACEBOOK_PAGEID":"718319861593356","NODE_ENV":"production","PUBLIC_DIR":"/home/circleci/project/public"}));
	  }
	  return _react2.default.createElement(
	    'div',
	    { className: '' + (hasFrame ? 'hasFrame' : '') },
	    _react2.default.createElement(_reactHelmet2.default, {
	      title: data.site.siteMetadata.title,
	      meta: [{ name: 'description', content: data.site.siteMetadata.description }]
	    }),
	    _react2.default.createElement(_header2.default, data.landing),
	    _react2.default.createElement(
	      'div',
	      { className: ContentClass },
	      children()
	    ),
	    _react2.default.createElement(_footer2.default, null)
	  );
	};
	
	Layout.propTypes = {
	  children: _propTypes2.default.func
	};
	
	exports.default = Layout;
	var query = exports.query = '** extracted graphql fragment **';

/***/ }),

/***/ 825:
/***/ (function(module, exports) {

	// empty (null-loader)

/***/ }),

/***/ 311:
/***/ (function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	var windowDocument = typeof document !== 'undefined' && document;
	
	var init = function init(env) {
	  if (windowDocument) {
	    var script = windowDocument.createElement("script");
	
	    script.innerHTML = "(function(){window.WhistleLiveChat={ company:'" + env.GATSBY_LIVE_CHAT_BUCKET + "', source: '" + env.GATSBY_PLUGINS_SOURCE + "' };var e=document.createElement(\"script\");e.async=!0,e.type=\"text/javascript\",e.src=window.WhistleLiveChat.source + \"/live-chat/initialize.js\";var t=document.getElementsByTagName(\"script\")[0];t.parentNode.insertBefore(e,t)}())";
	    script.async = true;
	    script.defer = true;
	
	    document.body.appendChild(script);
	  }
	};
	
	exports.default = init;
	module.exports = exports["default"];

/***/ })

});


// WEBPACK FOOTER //
// component---src-layouts-index-js-cd77fe88110e8bfcce71.js